module.exports = __webpack_public_path__ + "static/media/3-2_Side_Attached_03.e1153046.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/3-2_Side_Attached_03.jpg
// module id = 1735
// module chunks = 0